import { isUndefined } from '@aloft/toolkit-shared';
import { Banner } from '@aloft/toolkit-sui';

import { Entry } from 'contentful';

import { GlobalAlertBannerSkeleton } from './types.js';
import { useGlobalAlerts } from './useGlobalAlerts.js';

export function GlobalContentfulAlerts() {
  const { alerts, isLoading, isError } = useGlobalAlerts();

  if (isLoading || isError || isUndefined(alerts) || !alerts.length) {
    return null;
  }

  return alerts.map((alert) => <ContentfulAlertBanner key={alert.sys.id} alert={alert} />);
}

function ContentfulAlertBanner(props: {
  alert: Entry<GlobalAlertBannerSkeleton, undefined, string>;
}) {
  const { title, description, type } = props.alert.fields;
  const status = type === 'Error' ? 'error' : 'warning';

  return <Banner title={title} description={description} status={status} canDismiss={false} />;
}
